export function hashPrefixed(hex?: string): string {
  if (!hex) return ''
  return hex[0] === '#' ? hex : '#' + hex
}
